import React, { FC } from "react";
import styles from "./ContactModal.module.scss";
import closeIcon from "../../../../icons/close.svg";
import whatsappIcon from "../../../../icons/whatsapp_icon.svg";
import telegramIcon from "../../../../icons/telegram_icon.svg";

const { TELEGRAM, WHATSAPP_PHONE } = process.env;

interface ContactModalProps {
  onClose: () => void;
}

const ContactModal: FC<ContactModalProps> = ({ onClose }) => (
  <>
    <div className={styles.overlay} onClick={onClose}></div> 
    <div className={styles.modal}>
      <button onClick={onClose} className={styles.modalCloseButton}>
        <img src={closeIcon} alt="Закрыть" />
      </button>
      <h2 className={styles.modalTitle}>Хотите задать нам вопрос?</h2>
      <p>Напишите нам в мессенджер!</p>
      <div className={styles.messengers}>
        <a
          href={`https://wa.me/${WHATSAPP_PHONE}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={whatsappIcon} alt="WhatsApp" />
          <span>WhatsApp</span>
        </a>
        <a
          href={`https://t.me/${TELEGRAM}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={telegramIcon} alt="Telegram" />
          <span>Телеграм</span>
        </a>
      </div>
    </div>
  </>
);

export default ContactModal;
